import '@fortawesome/fontawesome-free/css/all.css'
import './styles/style.scss'

import carrier from './images/logo-vivo-vivinho.svg'

import { runApp } from '@/app-loader'

runApp({
  name: 'Vivo Recarga - Pagamento PIX',
  images: {
    carrier
  },
  config: {
    expiredRedirectUrl: 'https://recarga.vivo.com.br/recarga?startValue={{amount}}&paymentMethod=pix'
  }
})
